import React from "react";

/**
 * Tarjeta con título que agrupa los campos de una temática del formulario de
 * producto. `extra` va a la derecha del título (p. ej. "Agregar precio").
 */
const Seccion = ({ titulo, icono, extra, children, className = "" }) => (
	<section className={`form-seccion ${className}`}>
		<div className="form-seccion__encabezado">
			<h3 className="form-seccion__titulo">
				{icono && <i className={`${icono} mr-2`} aria-hidden="true" />}
				{titulo}
			</h3>
			{extra}
		</div>
		{children}
	</section>
);

/** Primer mensaje de validación (422) de un campo, si lo hay. */
export const ErrorCampo = ({ errors, campo }) =>
	errors?.[campo] ? (
		<small className="help-blockParams form-Text d-block">{errors[campo][0]}</small>
	) : null;

export default Seccion;
